import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BRAND, NAV_LINKS } from "../content";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeAndScroll = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "py-3 backdrop-blur-xl bg-[#140326]/70 border-b border-[#B48DFF]/15"
          : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/brand/logo.png?v=4"
            alt="DietDotIn — Premium Dietician in Bangalore"
            className="h-14 md:h-16 w-auto drop-shadow-[0_0_22px_rgba(122,43,255,0.6)] transition-transform duration-300 group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9 text-sm text-[#D8CCFF]">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="hover:text-white transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-gradient-to-r after:from-[#7A2BFF] after:to-[#27C6FF] hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#booking"
            data-testid="header-cta-book"
            className="hidden md:inline-flex btn-primary px-5 py-2.5 rounded-full text-sm font-semibold font-heading"
          >
            Book Consultation
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 rounded-full glass"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden mt-3 mx-5 rounded-2xl glass-strong p-5"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => closeAndScroll(l.href)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-left text-[#D8CCFF] hover:text-white font-heading"
              >
                {l.label}
              </button>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              className="btn-primary text-center py-3 rounded-full font-semibold font-heading"
              data-testid="mobile-cta-book"
            >
              Book Consultation
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
